export default __webpack_public_path__ + "static/media/news_image03.c189e730.png";